import { Injectable } from '@angular/core';
import { IDvmFormatter } from '@3ddv/software-division-components';

@Injectable({
  providedIn: 'root',
})
export class DvmFormatterService implements IDvmFormatter {
  transform(value: string, ...args: unknown[]): string {
    if (!value) return '';

    return value.replace(/-/g, ' ').toUpperCase();
  }
}
